import { useEffect, useState } from 'react';
import { blockChunkLoadRecovery, startChunkLoadRecovery } from 'utils/chunkLoadRecovery';

interface ChunkLoadErrorFallbackProps {
  release: string;
}

export function ChunkLoadErrorFallback({ release }: ChunkLoadErrorFallbackProps) {
  const [isRecovering] = useState(() => startChunkLoadRecovery(release));

  useEffect(() => {
    if (!isRecovering) blockChunkLoadRecovery();
  }, [isRecovering]);

  if (isRecovering) {
    return (
      <div
        aria-busy="true"
        data-testid="chunk-load-reload-placeholder"
        className="fixed inset-0 h-screen w-screen bg-white"
        style={{ zIndex: 2147483647 }}
      />
    );
  }

  return null;
}
